import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ChecklistSubCategory } from '../classes/checklistSubCategory';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class ChecklistSubCategoryService {
    API_CHECKLIST_SUB_CATEGORY_URL = config.serverAddress + ':' + config.serverPort + '/checklist-sub-category/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get(this.API_CHECKLIST_SUB_CATEGORY_URL + 'all');
    }
    getByID(id: string | null) {
        return this.http.get(this.API_CHECKLIST_SUB_CATEGORY_URL + id);
    }
    getByIDCategory(idCategory: string | null) {
        return this.http.get(this.API_CHECKLIST_SUB_CATEGORY_URL + 'checklist-category/' + idCategory);
    }
    create(checklistSubCategory: ChecklistSubCategory) {
        return this.http.post(this.API_CHECKLIST_SUB_CATEGORY_URL + 'create', checklistSubCategory);
    }
    update(checklistSubCategory: ChecklistSubCategory) {
        return this.http.put(this.API_CHECKLIST_SUB_CATEGORY_URL + 'update', checklistSubCategory);
    }
    delete(id: number | null) {
        return this.http.delete(this.API_CHECKLIST_SUB_CATEGORY_URL + 'delete/' + id);
    }
}